import React from 'react';
import { Skeleton } from 'antd';
import styles from './PricingDisplaySkeleton.module.css';

/**
 * Loading skeleton component that mimics the PricingDisplay layout
 * Shows animated placeholders while tier data is being fetched
 * @returns React.JSX.Element
 */
const PricingDisplaySkeleton = () => {
  return (
    <div className={styles.Container}>
      {/* Header skeleton */}
      <div className={styles.Header}>
        <Skeleton.Input active size="large" style={{ width: 300, height: 32 }} />
      </div>

      {/* Interval toggle skeleton */}
      <div className={styles.IntervalToggle}>
        <Skeleton.Input active size="small" style={{ width: 80, height: 20 }} />
        <div className={styles.SwitchSkeleton} />
        <div className={styles.IntervalWithBadge}>
          <Skeleton.Input active size="small" style={{ width: 80, height: 20 }} />
          <div className={styles.DiscountBadgeSkeleton} />
        </div>
      </div>

      {/* Tier cards skeleton */}
      <div className={styles.TierCardsGrid}>
        {[1, 2, 3, 4, 5].map((index) => (
          <div key={index} className={styles.TierCard}>
            {/* Tier header */}
            <div className={styles.TierHeader}>
              <div className={styles.TierIconSkeleton} />
              <div className={styles.TierInfo}>
                <Skeleton.Input active size="default" style={{ width: 100, height: 20 }} />
                <Skeleton.Input active size="small" style={{ width: 160, height: 14, marginTop: 8 }} />
              </div>
            </div>

            {/* Pricing section */}
            <div className={styles.PricingSection}>
              <div className={styles.PriceRow}>
                <Skeleton.Input active size="large" style={{ width: 80, height: 32 }} />
                <div className={styles.DiscountSkeleton} />
              </div>
              <Skeleton.Input active size="small" style={{ width: 120, height: 14, marginTop: 8 }} />
            </div>

            {/* Features section */}
            <div className={styles.FeaturesSection}>
              {[1, 2, 3, 4].map((featureIndex) => (
                <div key={featureIndex} className={styles.Feature}>
                  <div className={styles.FeatureIcon} />
                  <Skeleton.Input active size="small" style={{ width: 120, height: 16 }} />
                </div>
              ))}
            </div>

            {/* CTA button */}
            <div className={styles.CtaSection}>
              <Skeleton.Button active size="large" style={{ width: '100%', height: 40, borderRadius: '8px' }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingDisplaySkeleton;
